import { v3WithImageBg } from '@consumer/logic/v3'
import type { GiftlyDesign, GiftlyMetadata } from '@consumer/types/serializers'

/**
 * Determines if a design is a holiday design.
 * Matches the Ruby logic in app/values/giftly_designs.rb#holidays?
 */
export function isHolidayDesign (design: GiftlyDesign): boolean {
  const id = design.id
  const santa = id.includes('v3-holidays-2024-1')
  return id.includes('holidays') && !santa && !id.includes('gcip')
}

/**
 * Applies a design's theming onto a gift's metadata — the single place that
 * knows every field a design carries, so callers can't fall out of sync as
 * theming gains capabilities. A custom design (one backed by a background
 * image rather than a catalog entry) keeps `v3WithImageBg` as the design name.
 */
export function applyDesign (metadata: GiftlyMetadata, design: GiftlyDesign) {
  metadata.designName = design.custom ? v3WithImageBg : design.id
  metadata.backgroundColor = design.backgroundColor || null as any
  metadata.backgroundImageUrl = design.backgroundImageUrl
  metadata.maskName = design.maskName
  metadata.maskColor = design.maskColor
  metadata.logoColor = design.logoColor
  metadata.themeColor = design.themeColor
}
